module.exports = __webpack_public_path__ + "img/pic5.a2bfdf0e.png";